var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-badge',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip"}],attrs:{"title":_vm.title,"variant":"warning"}},[_c('gl-icon',{attrs:{"name":"spam"}}),_vm._v(" "),_c('span',{staticClass:"gl-sr-only"},[_vm._v(_vm._s(_vm.__('Hidden')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }